import * as React from 'react';

// @ts-expect-error
import type {FieldProps} from 'redux-form';

import {ErrorMessage} from 'shells/form/error-message';

import {Checkbox} from './checkbox';

type Props = {
    label: string;
    hasError?: boolean;
    input: FieldProps['input'];
    meta: FieldProps['meta'];
};

export class ReduxFormCheckbox extends React.PureComponent<Props> {
    render() {
        const {value, ...reduxFormProps} = this.props.input;

        return (
            <div>
                <Checkbox
                    isLarge={true}
                    {...reduxFormProps}
                    label={this.props.label}
                    hasError={this.props.hasError}
                    checked={value}
                />
                {this.props.meta.error ? (
                    <ErrorMessage>{this.props.meta.error}</ErrorMessage>
                ) : null}
            </div>
        );
    }
}
